import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";

import { Contributor } from "./ContributorBadge";
import ProjectLeaderBadge from "./ProjectLeaderBadge";
import ProjectLike from "./ProjectLike";
import ProjectTag from "./ProjectTag";
import ViewProjectButton from "./ViewProjectButton";

import classes from "./classes.module.scss";

type IProps = {
	projectId: string;
	title: string;
	description: string;
	poster: string;
	contributor: Contributor;
	likes: number;
	tags: {
		publicationDate: string;
		genre: string;
		format: string;
	}
};

export default function ProjectCard(props: IProps) {
	return (
		<div className={classes["root"]}>
			<div className={classes["content"]}>
				<div className={classes["project-container"]}>
					<div className={classes["poster-container"]}>
						<LazyImage src={props.poster} alt="" />
					</div>
					<div className={classes["project-infos"]}>
						<div className={classes["project-title-container"]}>
							<div className={classes["project-title"]}>
								<Typography type="p" size="large" weight="bold" color="white">
									{props.title}
								</Typography>
							</div>
							<div className={classes["project-description"]}>
								<Typography type="p" weight="regular" size="small" color="white" hide>
									{props.description}
								</Typography>
							</div>
						</div>
						<div className={classes["project-leader-badge"]}>
							<ProjectLeaderBadge contributor={props.contributor} />
						</div>
						<div className={classes["actions"]}>
							<ProjectLike likes={props.likes} />
							<ViewProjectButton project={{ id: props.projectId }} />
						</div>
					</div>
				</div>
				<div className={classes["project-metadata"]}>
					<ProjectTag tag={props.tags.genre} />
					<ProjectTag tag={props.tags.format} />
					<ProjectTag tag={props.tags.publicationDate} />
				</div>
			</div>
			<LazyImage src={props.poster} alt="" className={classes["background"]} />
		</div>
	);
}
